






import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import PayoutBoardOfferResourceList from '@superUI/ResourceList/PayoutBoardOfferResourceList'
import CsvExportResourceTriggerModal from '@triggers/Utils/CsvExportResourceTriggerModal'

settings =
  name: 'PayoutBoardOfferList'

  components: {
    SuperContainerView,
    PayoutBoardOfferResourceList,
    CsvExportResourceTriggerModal,
  }

  resources:
    offers:
      resourceName: 'offers'
      slug: 'offers'
      infinityScroll: true

  vue:
    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      csvExportResourceTrigger: (payloadOptions) ->
        params = {
          format: 'payout_board',
          ...payloadOptions,
          ...@exportCsvParams('offers', payloadOptions),
        }
        @$refs.csvExportResourceTrigger.fire(params)
      onOffersCsvExport: ->
        @$refs.csvExportResourceTrigger.close()
      onOffersCsvExportError: -> @showError('Failed to export CSV.')

export default VueOptions.vue settings
